import { ProgressBar, Row, Space } from "@masterteam/mt-design-react";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import DoughnutChart from "../../DoughnutChart";
import DetailsCard from "../DetailsCard";

import { useIsAr } from "../../../Hooks";

import { ReactComponent as InfoIcon } from "../../../assets/images/info-icon.svg";
import { ReactComponent as UserIcon } from "../../../assets/images/user.svg";

import "./style.scss";

const InfoCards = ({ initiative, projectStatuses, initiativeStatus }) => {
  const [isAr] = useIsAr();
  const intl = useIntl();
const status = initiativeStatus?.find((e) => e.Code === initiative?.Status);

  return (
    <Space className="info-cards" direction="vertical" size="large">
      <Row size="large" align="stretch">
        <Row size="large" align="stretch">
          <DetailsCard title="initiative.progress-percentage">
            <Row className="progress" gap="5px">
          <ProgressBar
          value={initiative?.Progress}
          color={status?.Color}
          title={intl.formatMessage({
            id: "common.actual-progress",
          })}
        />
         <span style={{ color: status?.Color, paddingTop: 22 }}> % {initiative.Progress}</span>

          </Row>

          <Row className="progress" gap="5px">
          <ProgressBar
          value={initiative?.PlannedProgress}
          title={intl.formatMessage({
            id: "common.planned-progress",
          })}
        />
         <span style={{ color: "#007DC5", paddingTop: 22 }}> % {initiative.PlannedProgress}</span>
          </Row>
          </DetailsCard>

          <DetailsCard
            title="common.project-status"
          >
            <Row justify="center" className="doughnut-chart-wrapper">
              <DoughnutChart
                data={initiative?.ProjectChart?.ChartData || []}
                statuses={projectStatuses}
                count={initiative?.ProjectChart?.Count}
                showNoData
                isProject
                // noClickEvent
                detailsTitle={"common.strategic-projects"}
                detailsData={initiative?.ProjectChart?.List ||[]}
                staticPlannedColor="#007DC5"
              />
            </Row>
          </DetailsCard>
        </Row>

        <DetailsCard
          icon={<InfoIcon />}
          title="initiative.description"
        >
          <Space direction="vertical" className="description-wrapper">
            <div className="text">
              {isAr
                ? initiative?.ArabicDescription
                : initiative?.EnglishDescription}
            </div>
            <Space gap={48}>
              <Space align="center" gap={8}>
                <Space align="center">
                  <UserIcon />
                  <FormattedMessage id="project.initiative-manager" />:
                </Space>
                <div>{initiative?.ManagerModel?.DisplayName}</div>
              </Space>
            </Space>
          </Space>
        </DetailsCard>
      </Row>
    </Space>
  );
};

export default InfoCards;
